<script setup lang="ts">
const props = defineProps({
  data: Object,
})
</script>

<template>
    <div class="bg-white rounded-xl p-5 h-24 gap-3 flex items-center justify-between transition">
        <h3 class="text-sm text-[#1b325a] font-medium mb-2">{{ data?.label }}</h3>
        <p
            class=" px-2 h-[52px] text-[22px] font-fa font-medium min-w-[52px] flex items-center justify-center  text-[#1b325a] bg-[#eaeef5] rounded-md ">
            {{ data?.price.toLocaleString() }}
        </p>
    </div>
</template>
